export default __webpack_public_path__ + "media/images/theme/m_logo_light-c85a13136d9e822ea25ea40162a51fdf.png";